import { z } from 'zod'
import { zId } from '../common'

// GET /admin/seo/platform — super_admin only. 403 for tenant_admin.

export const CIRCUIT_STATUSES = ['closed', 'open', 'half_open'] as const
export type CircuitStatus = (typeof CIRCUIT_STATUSES)[number]

export const zSeoPlatformCircuit = z
  .object({
    status: z.string(),
    failures: z.number(),
    openUntil: z.string().nullable(),
    lastError: z.string().nullable(),
  })
  .passthrough()
export type SeoPlatformCircuit = z.infer<typeof zSeoPlatformCircuit>

// Real API returns tenant rows with snake_case money keys (`spent_usd` /
// `budget_usd`); the rest of the envelope is camelCase. Accept both and
// normalize so the UI always reads camelCase.
export const zSeoPlatformTenant = z.preprocess(
  (raw) => {
    if (!raw || typeof raw !== 'object') return raw
    const row = raw as Record<string, unknown>
    return {
      ...row,
      spentUsd: row.spentUsd ?? row.spent_usd,
      budgetUsd: row.budgetUsd ?? row.budget_usd,
    }
  },
  z
    .object({
      id: zId,
      slug: z.string(),
      spentUsd: z.number(),
      budgetUsd: z.number(),
      pct: z.number().nullable().optional(),
      enabled: z.boolean(),
      mentions: z.boolean(),
    })
    .passthrough(),
)
export type SeoPlatformTenant = z.infer<typeof zSeoPlatformTenant>

export const zSeoPlatform = z
  .object({
    month: z.string(),
    spentUsd: z.number(),
    budgetUsd: z.number(),
    pct: z.number().nullable(),
    circuit: zSeoPlatformCircuit,
    dataforseoEnabled: z.boolean(),
    baseUrl: z.string(),
    liveOptIn: z.boolean(),
    pendingTasks: z.number(),
    tenants: z.array(zSeoPlatformTenant).default([]),
  })
  .passthrough()
export type SeoPlatform = z.infer<typeof zSeoPlatform>
